import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addToWisshList, getWishList, removeFromWishList } from "./wishListAPI";
import { WishlistDataState } from "../../../features/view/private/profilePage/components/ProfilePageTypes";

const initialState: WishlistDataState = {
  wishList: { data: [], loader: false },
};

export const addToWisshListAsync = createAsyncThunk(
  "products/wishlist/add/",
  async (id: any) => {
    const response = await addToWisshList(id);
    return response;
  }
);

export const removeFromWishListAsync = createAsyncThunk(
  "products/wishlist/remove/",
  async (id: any) => {
    const response = await removeFromWishList(id);
    return response;
  }
);

export const getWishListAsync = createAsyncThunk(
  "/products/wishlist/",
  async () => {
    const response = await getWishList();
    return response;
  }
);

export const wishListSlice = createSlice({
  name: "wishList",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(addToWisshListAsync.pending, (state) => {
        state.wishList.loader = true;
      })
      .addCase(addToWisshListAsync.fulfilled, (state, action: any) => {
        state.wishList.loader = false;

        const wishlistData = action?.payload?.data;

        state.wishList.data = Array.isArray(wishlistData)
          ? wishlistData
          : state.wishList.data; // Avoid breaking filter()
      })
      .addCase(addToWisshListAsync.rejected, (state) => {
        state.wishList.loader = false;
      })
      .addCase(removeFromWishListAsync.pending, (state) => {
        state.wishList.loader = true;
      })
      .addCase(removeFromWishListAsync.fulfilled, (state, action: any) => {
        const removedProductId = action.meta.arg; // The ID passed into the thunk
        state.wishList.data = state.wishList.data.filter(
          (item) => item.product_id !== removedProductId
        );
        state.wishList.loader = false;
      })
      .addCase(removeFromWishListAsync.rejected, (state) => {
        state.wishList.loader = false;
      })
      .addCase(getWishListAsync.fulfilled, (state, action: any) => {
        state.wishList.loader = false;
        const rawData = action?.payload?.data;

        const list = Array.isArray(rawData) ? rawData : rawData?.data;

        const filtered = Array.isArray(list)
          ? list.filter((item: any) => item.product_available === true)
          : [];

        // state.wishList.data = filtered;
        state.wishList.data = Array.isArray(list) ? list : [];

      });
  },
});

export default wishListSlice.reducer;
